import { REQUEST_REPORT_LIST, RECEIVE_REPORT_LIST } from '../constants'
import { HomeAction } from '../actions/home';

const home = (state: object = {}, action: HomeAction) => {
  switch (action.type) {
    case REQUEST_REPORT_LIST:
      return state
    case RECEIVE_REPORT_LIST:
      return Object.assign({}, state, {
        reportData: action
      })
    default:
      return state
  }
}
export default home



// WEBPACK FOOTER //
// ./src/reducers/home.tsx